<template>
  <div>
    <div class="row justify-content-center display-grid">
      <span class="strong"> {{ $t('topuptxt') }} </span>
      <fg-input style="width: 25rem;"
        v-model="amountToDeposit"
        type="number"
        :min="0"
        controls-position="right"
        size="large"
        @keyup="calcTaxes"
      >
      </fg-input>
    </div>
    <div class="row justify-content-center mb-2">
      <div class="col-md-10 alert alert-info" style="width: 30rem;">
        <i class="fa fa-info-circle mr-2 "></i>
        <span> {{ feeTxt }} </span>
        <span v-if="exchangeRate"> {{ exchangeRate }} </span>
        <span v-else> <i class="fa fa-spinner fa-spin fa-fw"></i> </span>
      </div>
    </div>
    <div class="row justify-content-center display-grid">
      <span class="strong"> {{ $t('amount_charged') }} </span>
      <el-input
        style="width: 25rem;"
        v-model="amountCharged"
        disabled
        class="bigger-symbol text-center">
        <template #prepend>{{ selectedCurrency.toUpperCase() }}</template>
      </el-input>
    </div>
    <div class="row justify-content-center mt-4">
      <p-button wide type="success"
                v-loading="isLoading || !exchangeRate"
                :disabled="!exchangeRate"
                v-on:click.prevent="submit">
        {{ $t('submit') }}
      </p-button>
    </div>
  </div>
</template>
<script>
import {Input, Option, Select, Tooltip} from "element-ui";

import Constants from "@/assets/constants";
import Vue from "vue";
const user_data = JSON.parse(localStorage.getItem('user-info'));

export default {
  name: "pixMethod",
  components: {
    [Input.name]: Input,
  },
  props: {
    selectedCurrency: { type: String, default: 'R$'},
  },
  computed: {
    feeTxt: {
      get()  {
         return this.$t('paysfixedfee') + ": $" +  this.fixedFee + " + " +
           this.$t('variablefee') + ": " +  this.percentFee + "% * " +
           this.$t('helper_excentry') + ": $"
      }
    },
  },
  data() {
    return {
      amountToDeposit: 0,
      tempAmount: 100,
      exchangeRate: 0,
      defaultModel: {
        type: 'deposit',
        method: {},
        value: 0,
        exchange_rate: 0,
        charge: 0,
        userid: user_data.email,
        integration_data: {},
        order: {},
      },
      pixMethod: [],
      amountCharged: 0,
      isLoading: false,
      percentFee: 0,
      fixedFee: 0,

    }
  },
  methods: {
    goToWalletOrder(order) {
      this.$router.push({name: 'wallet_order_title', params: {order: order}});
    },
    async getExchangeRate(value) {
      let response = await this.$getWalletExchange(value);
      this.exchangeRate =  parseFloat(response.data || 1).toFixed(4)
    },
    async calcTaxes() {
      this.amountCharged = parseFloat(
        (this.amountToDeposit * this.exchangeRate) +
        (
          this.fixedFee * this.exchangeRate + this.amountToDeposit * this.percentFee / 100 * this.exchangeRate
        )
      ).toFixed(2)
    },
    async submit() {
      this.isLoading = true;
      await this.submitOrder();
    },
    async submitOrder() {
      const response = await this.$createWalletOrder({
        type: 'deposit',
        method: this.pixMethod,
        value: this.amountToDeposit,
        exchange_rate: this.exchangeRate,
        charge: this.amountCharged,
        userid: user_data.email,
        method_id: this.pixMethod.id,
        integration_data: {},
      }).then(response => {
        if (!this.$validateResponse(response)) {
          return;
        }
        this.isLoading = false
        this.goToWalletOrder(response.data);
      }).catch(err => {
        this.$validateResponse(err.data);
      });
    },
  },
  mounted() {
    this.getExchangeRate(this.tempAmount)
  },
  async created() {
    let methodList = (await this.$getWalletMethods()).data || [];
    this.pixMethod = methodList.find( el => el.value == 'pix' )
    this.percentFee = this.pixMethod.percent_fee
    this.fixedFee = this.pixMethod.fixed_fee
  },
  watch: {
    'exchangeRate': function (newVal) {
      if (newVal) {
        this.calcTaxes()
      }
    }
  },
}
</script>
<style scoped>

</style>
